var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "团队话题",
        maskClosable: false,
        width: 600,
        destroyOnClose: true,
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 6 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.onlyMember,
                  expression: "!onlyMember",
                },
              ],
              attrs: { label: "聊天室名称" },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: [
                      "name",
                      {
                        rules: [
                          { required: true, message: "请输入聊天室名称" },
                        ],
                        initialValue: _vm.formData.name,
                      },
                    ],
                    expression:
                      "[\n          'name',\n          {\n            rules: [{ required: true, message: '请输入聊天室名称' }],\n            initialValue: formData.name\n          }\n        ]",
                  },
                ],
                attrs: { placeholder: "请输入聊天室名称" },
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            { attrs: { label: "团队成员" } },
            [
              _c("VSelect", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: [
                      "members",
                      {
                        rules: [{ required: true, message: "请选择团队成员" }],
                        initialValue: _vm.formData.members,
                      },
                    ],
                    expression:
                      "[\n          'members',\n          {\n            rules: [{ required: true, message: '请选择团队成员' }],\n            initialValue: formData.members\n          }\n        ]",
                  },
                ],
                attrs: {
                  maxTagCount: 1,
                  options: _vm.membersList,
                  optionsFields: { value: "user_id", label: "user_name" },
                  placeholder: "请选择团队成员",
                  mode: "multiple",
                },
                on: {
                  change: function ($event) {
                    return _vm.handleSelectChange($event)
                  },
                  clearValue: () => (_vm.formData.members = []),
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.onlyMember,
                  expression: "!onlyMember",
                },
              ],
              attrs: { label: "团队模板" },
            },
            [
              _c(
                "a-checkbox-group",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: [
                        "templates",
                        {
                          initialValue: _vm.formData.templates || [],
                        },
                      ],
                      expression:
                        "[\n          'templates',\n          {\n            initialValue: formData.templates || []\n          }\n        ]",
                    },
                  ],
                  style: { width: "100%", marginTop: "10px" },
                },
                [
                  _vm.templatesLoading
                    ? _c(
                        "div",
                        { staticClass: "template-loading" },
                        [
                          _c("a-spin", { attrs: { size: "small" } }),
                          _c("span", { staticClass: "loading-text" }, [
                            _vm._v("加载中..."),
                          ]),
                        ],
                        1
                      )
                    : _vm.teamTemplatesList.length === 0
                    ? _c("div", { staticStyle: { "margin-top": "-2px" } }, [
                        _vm._v(" 暂无模板 "),
                      ])
                    : _c(
                        "a-row",
                        _vm._l(_vm.teamTemplatesList, function (item) {
                          return _c(
                            "a-col",
                            {
                              key: item.team_prompt_id,
                              staticClass: "template-item",
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "template-item-content" },
                                [
                                  _c(
                                    "a-checkbox",
                                    { attrs: { value: item.team_prompt_id } },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "template-item-actions" },
                                    [
                                      _c(
                                        "a-tooltip",
                                        { attrs: { title: "编辑" } },
                                        [
                                          _c("a-icon", {
                                            staticClass: "template-action-icon",
                                            attrs: { type: "edit" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editTemplate(item)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-tooltip",
                                        { attrs: { title: "删除" } },
                                        [
                                          _c("a-icon", {
                                            staticClass: "template-action-icon",
                                            attrs: { type: "delete" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteTemplate(item)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                ],
                1
              ),
              _vm.teamTemplatesList.length < 10
                ? _c(
                    "a",
                    {
                      staticClass: "team-topic-add-template",
                      on: { click: _vm.showTemplateModal },
                    },
                    [
                      _c("a-icon", { attrs: { type: "plus" } }),
                      _vm._v(" 新增团队模板 "),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "template-limit-tip" },
                    [
                      _c("a-icon", { attrs: { type: "info-circle" } }),
                      _vm._v(" 最多添加10个团队模板 "),
                    ],
                    1
                  ),
            ],
            1
          ),
          _vm.sourceSessionId
            ? _c(
                "a-form-item",
                { attrs: { label: "个人转团队" } },
                [
                  _c(
                    "a-checkbox",
                    {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "clearHistory",
                            {
                              valuePropName: "checked",
                              initialValue: true,
                            },
                          ],
                          expression:
                            "[\n          'clearHistory',\n          {\n            valuePropName: 'checked',\n            initialValue: true\n          }\n        ]",
                        },
                      ],
                    },
                    [_vm._v(" 把当前会话转为团队话题并清空历史聊天消息 ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")]),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
      _c("team-template-modal", {
        attrs: {
          visible: _vm.templateModalVisible,
          loading: _vm.templateConfirmLoading,
          formData: _vm.templateFormData,
        },
        on: {
          cancel: _vm.handleTemplateCancel,
          submit: _vm.handleTemplateSubmit,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }